import { UserOutlined, LockOutlined, EyeTwoTone, EyeInvisibleOutlined } from '@ant-design/icons';
import { Form, Input, Button, Typography, Row, Col, Card, Divider, Space } from 'antd';
import React, { FC, useState } from 'react';
import { useLogin, login, useLoginVerify } from '../../api/auth';
import { Page } from '../../components/Page/Page';
import classes from './Login.module.scss';

const { Text } = Typography;

export const Login: FC = () => {
  const [validation, setValidation] = useState(null);
  const [verifyLoginUrl, setVerifyLoginUrl] = useState<string | undefined>(undefined);
  const handleLogin = useLogin();
  const handleTotp = useLoginVerify();

  const onSubmit = (values: any) => {
    handleLogin.mutate(values, {
      onError: (error: any) => {
        setValidation(error.response.data.error);
      },
      onSuccess: (data: any) => {
        if ('verifyUrl' in data) {
          setVerifyLoginUrl(data.verifyUrl);
        } else {
          login(data.data);
        }
      },
    });
  };

  const onTotpSubmit = (values: any) => {
    handleTotp.mutate(
      { ...values, url: verifyLoginUrl },
      {
        onError: (error: any) => {
          setValidation(error.response.data.error.otp[0]);
        },
        onSuccess: (data: any) => {
          login(data.data);
        },
      }
    );
  };

  const resetStates = () => {
    setValidation(null);
  };

  const LoginForm: FC = () => {
    return (
      <Form
        name="userLogin"
        className="login-form"
        initialValues={{ remember: true }}
        onFinish={onSubmit}
        onChange={resetStates}
      >
        <Form.Item
          name="username"
          rules={[{ required: true, message: 'Please input your Username!' }]}
        >
          <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Please input your Password!' }]}
        >
          <Input.Password
            prefix={<LockOutlined className="site-form-item-icon" />}
            placeholder="Password"
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>
        <Form.Item hidden={validation === null}>
          <div>
            <Text type="danger">{validation}</Text>
          </div>
        </Form.Item>
        <Form.Item>
          <Space>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
              loading={handleLogin.isLoading}
            >
              Log in
            </Button>
          </Space>
        </Form.Item>
      </Form>
    );
  };

  const VerifyLoginForm: FC = () => {
    return (
      <Form
        name="userLoginVerification"
        className="verify-login-form"
        initialValues={{ remember: true }}
        onFinish={onTotpSubmit}
        onChange={resetStates}
      >
        <Form.Item
          name="otp"
          rules={[{ required: true, message: 'Please input One Time Password!' }]}
        >
          <Input placeholder="OTP" />
        </Form.Item>
        <Form.Item hidden={validation === null}>
          <div>
            <Text type="danger">{validation}</Text>
          </div>
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
            loading={handleLogin.isLoading}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    );
  };

  return (
    <Page metaDescriptionContent="Login" title="Login">
      <Row className={classes.loginpage}>
        <Col span={8}>
          <div className={classes.advertise}>
            <Card cover={<img alt="APBS Logo" src={`${process.env.REACT_APP_DOMAIN}bank-logo/`} />}>
              <Card.Meta title="Any platform Banking System" description="One Bank N solutions" />
            </Card>
          </div>
        </Col>
        <Col span={8}>
          <div className={classes.loginform}>
            <img alt="APBS Logo" src="/logo.png" />
            <Divider />

            {verifyLoginUrl === undefined ? <LoginForm /> : <VerifyLoginForm />}
          </div>
        </Col>
      </Row>
    </Page>
  );
};
